import Layout from '@/pages/Layout';

export default [
    {
        path: '/process',
        redirect: 'noredirect',
        name: 'process',
        component: Layout,
        meta: {
            title: '流程中心',
            icon: 'el-icon-share'
        },
        children: [
            {
                path: 'design',
                component: () => import('@/pages/process/ProcessList/ProcessDesign'),
                name: 'design',
                id: 'process/design',
                props: {
                    processType: 'design'
                },
                meta: {
                    title: '流程定义',
                    icon: 'iconfont icon-other-liucheng2 bc-custom-menu'
                },
                isDesign: true,
                isTitle: false,
                isMenuWaterfall:false
                // isSubMenu: true
            },
            {
                path: 'processDesignTitle',
                name: 'processDesignTitle',
                id: 'processDesignTitle',
                meta: {
                    title: '流程设计',
                    icon: 'iconfont icon-other-liuchengtu bc-custom-menu',
                    color: '#0dd75e'
                },
                sortOrder: 41,
                isDesign: true,
                isTitle: true,
                isShow: false,
                isMenuWaterfall:true
                // isSubMenu: true
            },
            {
                pId: 'processDesignTitle',
                path: 'approvalDefinitionDesign',
                component: () => import('@/pages/process/ProcessList/ApprovalDefinitionDesign'),
                name: 'approvalDefinitionDesign',
                id: 'process/approvalDefinitionDesign',
                props: {
                    processType: 'approvalDefinitionDesign'
                },
                meta: {
                    title: '审批流设计',
                    icon: 'iconfont icon-other-flow-line bc-custom-menu',
                    color: '#81f615'
                },
                isShow: false,
                isSubMenu: true,
                sortOrder: 42,
                isDesign: true,
                isMenuWaterfall:true
            },
            {
                pId: 'processDesignTitle',
                path: 'processDefinitionDesign',
                component: () => import('@/pages/process/ProcessList/NewProcessDesign'),
                name: 'processDefinitionDesign',
                id: 'process/processDefinitionDesign',
                props: {
                    processType: 'processDefinitionDesign'
                },
                meta: {
                    title: '业务流设计',
                    icon: 'iconfont icon-other-liucheng2 bc-custom-menu',
                    color: '#53a019'
                },
                isShow: false,
                isSubMenu: true,
                sortOrder: 43,
                isDesign: true,
                isMenuWaterfall:true
            },
            {
                // pId: 'processDesignTitle',
                path: 'edit',
                component: () => import('@/pages/process/ProcessList/ProcessEdit'),
                name: 'edit',
                id: 'process/edit',
                props: {
                    processType: 'edit'
                },
                meta: {
                    title: '流程方案',
                    icon: 'el-icon-s-operation'
                },
                sortOrder: 44,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:false
            },
            {
                pId: 'processDesignTitle',
                path: 'time-config',
                component: () => import('@/pages/process/TimeConfig/TimeConfigList'),
                name: 'time-config',
                id: 'process/time-config',
                meta: {
                    title: '项目模板',
                    icon: 'iconfont icon-other-xiangmuguanli bc-custom-menu',
                    color: '#7bb64e'
                },
                sortOrder: 45,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'processDesignTitle',
                path: 'close-template',
                component: () => import('@/pages/process/CloseTemplate/CloseTemplateList'),
                name: 'close-template',
                id: 'process/close-template',
                meta: {
                    title: '闭环模板',
                    icon: 'iconfont icon-other-huanxingtu bc-custom-menu',
                    color: '#53b839'
                },
                sortOrder: 46,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                // pId: 'processDesignTitle',
                path: 'template',
                component: () => import('@/pages/process/ProcessTemplate'),
                name: 'template',
                id: 'process/template',
                meta: {
                    title: '流程模板',
                    icon: 'iconfont icon-other-liuchengmoban bc-custom-menu',
                    color: '#3210ee'
                },
                isMenuWaterfall:true
            },
            {
                pId: 'process/template',
                path: 'processTemplateApproval',
                component: () => import('@/pages/process/ProcessTemplate/ProcessTemplateApproval'),
                name: 'processTemplateApproval',
                id: 'process/processTemplateApproval',
                meta: {
                    title: '审批流模板',
                    icon: 'iconfont icon-other-shenpiliu bc-custom-menu',
                    color: '#2b1fdf'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'process/template',
                // pId2: 'processDesignTitle',
                path: 'processTemplateProcess',
                component: () => import('@/pages/process/ProcessTemplate/ProcessTemplateProcess'),
                name: 'processTemplateProcess',
                id: 'process/processTemplateProcess',
                meta: {
                    title: '业务流模板',
                    icon: 'iconfont icon-other-yewuliu bc-custom-menu',
                    color: '#1b32d5'
                },
                isShow: false,
                isSubMenu: true,
                isIgnore: true,
                sortOrder: 48,
                isMenuWaterfall:true
            },
            {
                path: 'myApproval/:approvalInstanceId',
                component: () => import('@/pages/process/MyApproval'),
                // redirect: 'noredirect',
                name: 'myApproval',
                id: 'process/myApproval/:approvalInstanceId',
                meta: {
                    title: '我的审批',
                    icon: 'iconfont icon-other-wodeshenpi bc-custom-menu',
                    color: '#193ce6'
                },
                isMenuWaterfall:true
            },
            {
                pId: 'process/myApproval/:approvalInstanceId',
                path: 'myApprovalApply',
                component: () => import('@/pages/workbench/MyApply'),
                // redirect: 'noredirect',
                name: 'myApprovalApply',
                id: 'process/myApprovalApply',
                meta: {
                    title: '我申请的',
                    icon: 'iconfont icon-other-tubiaolunkuo_huaban bc-custom-menu',
                    color: '#3a32ba'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'process/myApproval/:approvalInstanceId',
                path: 'myApprovalApprove',
                component: () => import('@/pages/workbench/MyApprove'),
                // redirect: 'noredirect',
                name: 'myApprovalApprove',
                id: 'process/myApprovalApprove',
                meta: {
                    title: '我审批的',
                    icon: 'iconfont icon-other-Group- bc-custom-menu',
                    color: '#5331db'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'process/myApproval/:approvalInstanceId',
                path: 'myApprovalCarbonCopy',
                component: () => import('@/pages/workbench/MyCarbonCopy'),
                // redirect: 'noredirect',
                name: 'myApprovalCarbonCopy',
                id: 'process/myApprovalCarbonCopy',
                meta: {
                    title: '抄送我的',
                    icon: 'iconfont icon-other-chaosongwode1 bc-custom-menu',
                    color: '#3025d9'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                path: 'myProcess/:processInstanceId',
                component: () => import('@/pages/process/MyProcess'),
                // redirect: 'noredirect',
                name: 'myProcess',
                id: 'process/myProcess/:processInstanceId',
                meta: {
                    title: '我的流程',
                    icon: 'iconfont icon-other-wodeliucheng bc-custom-menu',
                    color: '#1208ae'
                },
                isMenuWaterfall:true
            },
            {
                pId: 'process/myProcess/:processInstanceId',
                path: 'myProcessStartedBy',
                component: () => import('@/pages/process/MyProcess/MyProcessStartedBy'),
                name: 'myProcessStartedBy',
                id: 'process/myProcessStartedBy',
                props: {
                    processType: 'myProcessStartedBy'
                },
                meta: {
                    title: '我发起的',
                    icon: 'iconfont icon-other-wofaqide bc-custom-menu',
                    color: '#591bd3'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'process/myProcess/:processInstanceId',
                path: 'myProcessParticipant',
                component: () => import('@/pages/process/MyProcess/MyProcessParticipant'),
                name: 'myProcessParticipant',
                id: 'process/myProcessParticipant',
                props: {
                    processType: 'myProcessParticipant'
                },
                meta: {
                    title: '我参与的',
                    icon: 'iconfont icon-other-wocanyude bc-custom-menu',
                    color: '#34229c'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'process/myProcess/:processInstanceId',
                path: 'myProcessAssignee',
                component: () => import('@/pages/process/MyProcess/MyProcessAssignee'),
                name: 'myProcessAssignee',
                id: 'process/myProcessAssignee',
                props: {
                    processType: 'myProcessAssignee'
                },
                meta: {
                    title: '流程负责人',
                    icon: 'iconfont icon-other-ziyuan188 bc-custom-menu',
                    color: '#4d0da2a6'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                path: 'myTask',
                component: () => import('@/pages/process/MyTask'),
                // redirect: 'noredirect',
                name: 'myTask',
                id: 'process/myTask',
                meta: {
                    title: '我的任务',
                    icon: 'iconfont icon-other-renwu bc-custom-menu',
                    color: '#7908f4'
                },
                isMenuWaterfall:true
            },
            {
                pId: 'process/myTask',
                path: 'myTaskAssignee',
                component: () => import('@/pages/process/MyTask/MyTaskAssignee'),
                // redirect: 'noredirect',
                name: 'myTaskAssignee',
                id: 'process/myTaskAssignee',
                meta: {
                    title: '我负责的',
                    icon: 'iconfont icon-other-xinjianfangan bc-custom-menu',
                    color: '#8f39ddd1'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'process/myTask',
                path: 'myTaskParticipant',
                component: () => import('@/pages/process/MyTask/MyTaskParticipant'),
                // redirect: 'noredirect',
                name: 'myTaskParticipant',
                id: 'process/myTaskParticipant',
                meta: {
                    title: '我参与的',
                    icon: 'iconfont icon-other-wocanyude bc-custom-menu',
                    color: '#6c06ac'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            {
                pId: 'process/myTask',
                path: 'myTaskCarbonCopy',
                component: () => import('@/pages/process/MyTask/MyTaskCarbonCopy'),
                // redirect: 'noredirect',
                name: 'myTaskCarbonCopy',
                id: 'process/myTaskCarbonCopy',
                meta: {
                    title: '抄送我的',
                    icon: 'iconfont icon-other-wocanyude bc-custom-menu',
                    color: '#6c06ac'
                },
                isShow: false,
                isSubMenu: true,
                isMenuWaterfall:true
            },
            // {
            //     path: 'processData',
            //     component: () => import('@/pages/process/ProcessData'),
            //     // redirect: 'noredirect',
            //     name: 'processData',
            //     id: 'process/processData',
            //     meta: {
            //         title: '流程数据',
            //         icon: 'beer'
            //     }
            // },
            // {
            //     path: 'dynamics',
            //     component: () => import('@/pages/process/ProcessDynamics'),
            //     // redirect: 'noredirect',
            //     name: 'dynamics',
            //     meta: {
            //         title: '流程动态',
            //         icon: 'beer'
            //     }
            // },

            {
                path: 'design/:processDefinitionId',
                component: () => import('@/pages/process/ProcessEditor'),
                props: {
                    processType: 'design'
                },
                isShow: false,
                name: 'processDesign',
                id: 'process/design/:processDefinitionId',
                meta: {
                    title: '流程定义修改',
                    icon: 'beer'
                },
                isMenuWaterfall:false
            },

            {
                path: 'edit/:processDefinitionId/:processServiceId/:deploymentId',
                component: () => import('@/pages/process/ProcessEditor'),
                props: {
                    processType: 'edit'
                },
                isShow: false,
                name: 'processEditor',
                id: 'process/edit/:processDefinitionId/:processServiceId/:deploymentId',
                meta: {
                    title: '流程方案',
                    icon: 'beer'
                },
                isMenuWaterfall:false
            },
            {
                path: 'view/:processDefinitionId',
                component: () => import('@/pages/process/ProcessEditor'),
                props: {
                    processType: 'view'
                },
                isShow: false,
                name: 'processDetail',
                id: 'process/view/:processDefinitionId',
                meta: {
                    title: '流程详情',
                    icon: 'beer'
                },
                isMenuWaterfall:false
            },
            {
                path: 'historyView/:processDefinitionId/:pModelId',
                component: () => import('@/pages/process/ProcessEditor'),
                props: {
                    processType: 'historyView'
                },
                isShow: false,
                name: 'processHistory',
                id: 'process/historyView/:processDefinitionId/:pModelId',
                meta: {
                    title: '流程历史',
                    icon: 'beer'
                },
                isMenuWaterfall:false
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-process.js